import { StyleSheet } from "react-native"

export const styles = StyleSheet.create({
	questionContainer: {
		paddingHorizontal: 16
	},
	inputInnerContainer: {
		paddingHorizontal: 8
	}
})